import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';
import { fromJS } from 'immutable';

import { updateCallRouting } from 'flow/actions/call-routing-actions';
import { fetchProfiles } from 'flow/actions/profile-actions';
import Loading from 'flow/components/ui-components/Loading';
import RadioButton from 'flow/components/ui-components/RadioButton';
import useAppContext from 'flow/hooks/useAppContext';
import useProfiles from 'flow/hooks/useProfiles';
import { BlockistParams } from 'flow/types/Params';
import { routes } from 'flow/types/routes';

import { generatePath } from 'flow/utils/router-utils';
import Page from '../Page';

const EditCallRoutingAction = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey, blocklistKey, type } = useParams<BlockistParams>();
    const { profiles } = useProfiles(extensionKey);

    const callRouting = useAppSelector((state) =>
        state.callRoutings.getIn([type, blocklistKey]),
    );

    useEffect(() => {
        fetchProfiles(extensionKey);
    }, []);

    if (!callRouting) {
        return <Loading />;
    }

    const updateCallRoutingActionAndGoBack = (description: string | null) => {
        let updatedCallRoutingDTO: any;
        if (description === null) {
            updatedCallRoutingDTO = callRouting.delete('profileDTO');
        } else {
            updatedCallRoutingDTO = callRouting.update('profileDTO', () => {
                return fromJS({
                    description: description,
                });
            });
        }

        dispatch(updateCallRouting(updatedCallRoutingDTO));

        history.push(
            generatePath(
                routes[
                    'settings.softphone.advanced.callrouting.type.blocklistKey'
                ],
                { extensionKey, type, blocklistKey },
            ),
        );
    };

    return (
        <Page
            header={'settings.callrouting.during'}
            onClickBack={() =>
                history.push(
                    generatePath(
                        routes[
                            'settings.softphone.advanced.callrouting.type.blocklistKey'
                        ],
                        { extensionKey, type, blocklistKey },
                    ),
                )
            }
        >
            <RadioButton
                name="all-profiles"
                onChange={() => updateCallRoutingActionAndGoBack(null)}
                checked={!callRouting.getIn(['profileDTO', 'description'])}
            >
                {i18next.t('settings.callrouting.profile.allprofiles')}
            </RadioButton>
            {profiles.map((profile) => (
                <RadioButton
                    name={profile.get('key')}
                    onChange={() =>
                        updateCallRoutingActionAndGoBack(
                            profile.get('description'),
                        )
                    }
                    checked={
                        callRouting.getIn(['profileDTO', 'description']) ===
                        profile.get('description')
                    }
                >
                    {profile.get('description')}
                </RadioButton>
            ))}
        </Page>
    );
};

export default EditCallRoutingAction;
